<template>
  <s-task-list-layout :title="$chPtObjData('attentionChinName', workItem)">
    <template>
      <!-- <div class="my-1 pa-2 pt-0 d-flex">
        <s-internal-proposal />
        <v-spacer />
      </div> -->
      <!-- <v-chip-group
        mandatory
        active-class="primary--text"
        class="mb-2 ml-2"
      >
        <v-chip>
          <v-avatar
            left
            class="darken-2"
          >
            0
          </v-avatar> 高炳坤
        </v-chip>
        <v-chip>
          <v-avatar
            left
          >
            0
          </v-avatar> 馮若儀
        </v-chip>
        <v-chip>
          <v-avatar
            left
          >
            0
          </v-avatar> 曹錦俊
        </v-chip>
      </v-chip-group> -->
      <v-chip-group
        mandatory
        active-class="primary--text"
        class="mb-2 ml-2"
      >
        <template v-for="(staff) in myAttentionStaffs">
          <v-chip
            :key="staff.euid"
            @click="getActiveWorkItems(staff.euid)"
          >
            {{ $chPtObjData('chinStaffName', staff) }}
            <v-avatar
              right
              class="darken-2"
            >
              {{ staff.tasksCount }}
            </v-avatar>
          </v-chip>
        </template>
      </v-chip-group>
      <template>
        <v-list three-line>
          <template v-for="(trainingTask) in activeItems">
            <!-- Show only on xsOnly -->
            <v-list-item
              :key="trainingTask.proposalClassId"
              v-ripple
            >
              <v-list-item-content>
                <v-list-item-title>{{ $chPtObjData('chinTaskListTitle', trainingTask) }} </v-list-item-title>
                <v-list-item-subtitle>
                  <span class="primary--text mr-2">{{ $t('TaskList.WaitingApproveCount') }}：{{ trainingTask.listFollowingTrainingTaskDetail.length }}</span> <br>
                  {{ $chPtObjData('chinTaskListDesc2', trainingTask) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <div
              :key="trainingTask.proposalClassId"
              class="text-right mt-2"
            >
              <v-dialog
                v-model="showDialog"
                max-width="500"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    small
                    color="light-blue"
                    v-on="on"
                  >
                    <v-icon>
                      {{ mdiRedo }}
                    </v-icon>
                    <!-- 轉交 -->
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text>
                    <s-search-staff
                      show-support-staff
                      :select.sync="reassignedToEuid"
                      :label="$t('TaskList.TransferToOthers')"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      @click="showDialog = false"
                    >
                      {{ $t('PublicServant.Action.Close') }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="transferTaskToStaff(trainingTask, reassignedToEuid)"
                    >
                      {{ $t('ConfirmModal.OK') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </template>
        </v-list>
      </template>
    </template>
  </s-task-list-layout>
</template>

<script>

import STaskListLayout from './components/STaskListLayout'
// import SInternalProposal from './components/SInternalProposal'
// import STrainingList from './components/STrainingList'
import { mapState } from 'vuex'
import store from '../../store'
import { trainingTLModule, workflowModule, globalModule } from '../../store/moduleName'
import constant from '../../constant/constant'
import { setTimeout } from 'timers'
import SSearchStaff from '../../components/SSearchStaff'
import workflowApi from '../../api/workflow/workflow'
import { mdiRedo } from '@mdi/js'

// We're dynamically registering the
// `taskList` store module. This has
// the benefit of only loading this
// module, if it's actually needed.
// Before registering the module, we're
// checking if it's already registered
// which can happen in combination with
// webpacks hot reloading.
if (!store.state[trainingTLModule]) store.registerModule(trainingTLModule)

export default {
  components: {
    STaskListLayout,
    SSearchStaff
    // SInternalProposal,
    // STrainingList
  },
  data: () => {
    return {
      mdiRedo: mdiRedo,
      showDialog: false
    }
  },
  computed: {
    ...mapState({
      activeItems: state => state[trainingTLModule].attentionActiveWorkItems,
      workItem: state => state[workflowModule].item,
      myAttentionStaffs: state => state[workflowModule].myAttentionStaffs
    })
  },
  created () {
    this.$store.dispatch(workflowModule + '/getItemByBusinessCode', constant.BUSINESS_CODE.TRAINING)
    this.$store.dispatch(workflowModule + '/getMyAttentionStaffs', constant.BUSINESS_CODE.TRAINING)
    setTimeout(() => {
      this.$store.dispatch(trainingTLModule + '/getAttentionActiveItems', this.myAttentionStaffs[0].euid)
    }, 500)
  },
  methods: {
    getActiveWorkItems (euid) {
      this.$store.dispatch(trainingTLModule + '/getAttentionActiveItems', euid)
    },
    transferTaskToStaff: function (trainingTask, euid) {
      // task.show = false
      trainingTask.listFollowingTrainingTaskDetail.forEach(task => {
        workflowApi.transferTaskToStaff(cb => {
          if (cb.status === 201 || cb.status === 200) {
            this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('TaskList.Transfer.SuccessMessage'))
          }
          this.loading = false
          this.$store.dispatch(workflowModule + '/getMyAttentionStaffs', constant.BUSINESS_CODE.TRAINING)
          setTimeout(() => {
            this.$store.dispatch(trainingTLModule + '/getAttentionActiveItems', this.myAttentionStaffs[0].euid)
          }, 500)
        }, task.workItemId, euid, '')
      }
      )
    }
  }
}
</script>
